import { Card } from '@cimpress/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InvestigateSku from '../InvestigateSku';
import { css } from 'emotion';

const cardBody = css({
  '& > .card-block': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
});

function InvestigateSkusCard() {
  const { t } = useTranslation();

  return (
    <Card header={t('landingPage:investigateSkusCard:header')} isMinimal className={cardBody}>
      <p className="card-text">{t('landingPage:investigateSkusCard:cardBody')}</p>
      <InvestigateSku style={{ alignSelf: 'end' }} />
    </Card>
  );
}

export default InvestigateSkusCard;
